<div [ngbTooltip]="tooltip" placement="right" container="body" class="step-status-indicator {{ kind }}"></div>
